import React, { Component } from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { setHeader } from '../../actions/header-actions';
import { ensureSegmentLoaded } from '../../utils/segment';

const identifyUser = (user) => {
    if (window?.analytics) {
        const { email, firstName, lastName } = user;
        window.analytics.identify(user.id, {
            email,
            firstName,
            lastName,
        });
    }
};

const withTracker = (WrappedComponent) => {
    const trackPage = (page, isAuthenticated, properties) => {
        if (isAuthenticated && window?.analytics) {
            window.analytics.page(page, properties || {});
        }

        if (window?.pixie) {
            window.pixie('event', 'LandingPage');
        }
    };

    const HOC = class extends Component {
        componentDidMount() {
            const { auth } = this.props;
            const page = this.props.location.pathname + this.props.location.search;
            if (auth.user) {
                ensureSegmentLoaded();
                identifyUser(auth.user);
            } else if (window?.analytics) {
                const userId = window?.analytics.user && window?.analytics.user().id();
                if (userId) {
                    window.analytics.reset();
                }
            }
            trackPage(page, !!auth.user);
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            const { setHeaderOptions, auth } = this.props;

            const matchedRoutes = matchRoutes(this.props.route.routes, nextProps.location.pathname);
            const nextRoute = matchedRoutes[0]?.route;

            setHeaderOptions(nextRoute?.header ? nextRoute.header : {});

            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                if (currentPage) {
                    trackPage(nextPage, !!auth.user, {
                        referrer: currentPage,
                    });
                } else {
                    trackPage(nextPage, !!auth.user);
                }
            }
        }

        componentDidUpdate(prevProps) {
            const { auth } = this.props;
            // Auth resolves after mount in this repo (no real SSR), so the login transition — not
            // just componentDidMount — is where an authenticated visitor's Segment tracking begins.
            // Fire the landing page() directly (not via trackPage) so the out-of-scope pixie event
            // is not re-sent here.
            if (!prevProps.auth.user && auth.user) {
                ensureSegmentLoaded();
                identifyUser(auth.user);
                if (window?.analytics) {
                    const page = this.props.location.pathname + this.props.location.search;
                    window.analytics.page(page, {});
                }
            }
            if (prevProps.auth.user && !auth.user) {
                if (window?.analytics) {
                    window.analytics.reset();
                }
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    function mapStateToProps({ auth }) {
        return { auth };
    }

    return connect(mapStateToProps, { setHeaderOptions: setHeader })(HOC);
};

export default withTracker;
